var render, staticRenderFns
import script from "./maintenanceRecords.vue?vue&type=script&lang=js&"
export * from "./maintenanceRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e5c05",
  null
  
)

export default component.exports